module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eEQOm"))).then(() => parcelRequire('1iHdE'));